"use strict";

module.exports = {
  HTML5: require("./HTML5")
};


/*****************
 ** WEBPACK FOOTER
 ** /code/~/react-dnd/dist-modules/backends/index.js
 ** module id = 1057
 ** module chunks = 1
 **/